var map = {
	"./ft_t-2_stitch_blk.png": 236125,
	"./ft_t-2_stitch_blu.png": 719843,
	"./ft_t-2_stitch_cml.png": 18216,
	"./ft_t-2_stitch_crk.png": 453526,
	"./ft_t-2_stitch_grn.png": 915079,
	"./ft_t-2_stitch_lgd.png": 542137,
	"./ft_t-2_stitch_lsl.png": 40805,
	"./ft_t-2_stitch_nvy.png": 436209,
	"./ft_t-2_stitch_orn.png": 690111,
	"./ft_t-2_stitch_pnk.png": 486693,
	"./ft_t-2_stitch_ppl.png": 318116,
	"./ft_t-2_stitch_red.png": 600053,
	"./ft_t-2_stitch_sax.png": 917160,
	"./ft_t-2_stitch_wht.png": 799715,
	"./ft_t-2_stitch_ylw.png": 157394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 561273;